/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateTippingOrderDto,
    IdResponse,
    PreviewTippingOrderDto,
    PreviewTippingOrderResponse,
} from '../models';

export interface TippingOrderApiControllerCreateOrderRequest {
    createTippingOrderDto: CreateTippingOrderDto;
}

export interface TippingOrderApiControllerPreviewOrderRequest {
    previewTippingOrderDto: PreviewTippingOrderDto;
}

/**
 * 
 */
export class TippingOrderApi extends runtime.BaseAPI {

    /**
     */
    async tippingOrderApiControllerCreateOrderRaw(requestParameters: TippingOrderApiControllerCreateOrderRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.createTippingOrderDto === null || requestParameters.createTippingOrderDto === undefined) {
            throw new runtime.RequiredError('createTippingOrderDto','Required parameter requestParameters.createTippingOrderDto was null or undefined when calling tippingOrderApiControllerCreateOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/tipping-orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTippingOrderDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async tippingOrderApiControllerCreateOrder(requestParameters: TippingOrderApiControllerCreateOrderRequest): Promise<IdResponse> {
        const response = await this.tippingOrderApiControllerCreateOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async tippingOrderApiControllerPreviewOrderRaw(requestParameters: TippingOrderApiControllerPreviewOrderRequest): Promise<runtime.ApiResponse<PreviewTippingOrderResponse>> {
        if (requestParameters.previewTippingOrderDto === null || requestParameters.previewTippingOrderDto === undefined) {
            throw new runtime.RequiredError('previewTippingOrderDto','Required parameter requestParameters.previewTippingOrderDto was null or undefined when calling tippingOrderApiControllerPreviewOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/tipping-orders:preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewTippingOrderDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async tippingOrderApiControllerPreviewOrder(requestParameters: TippingOrderApiControllerPreviewOrderRequest): Promise<PreviewTippingOrderResponse> {
        const response = await this.tippingOrderApiControllerPreviewOrderRaw(requestParameters);
        return await response.value();
    }

}
